import React, { Component, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { Card, CardHeader, CardBody, Row, Col, Button, Input, Label, Form, FormGroup, Alert, FormFeedback } from 'reactstrap'
import { validationHelper, normalizeHelper } from '../../../../common/helpers'
import { messages } from '../../../../common/constants'
import { toast } from 'react-toastify'
import { createNewsletter, resetCreateNewsletter } from '../../../../store/newsletter/actions'
import { MainLoader } from '../../../../components';
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateType);

function NewsletterAdd(props) {
  const
    [previewImg, setPreviewImg] = useState(null),
    [mainImg, setMainImg] = useState(null),
    { handleSubmit, loading, error } = props;

  useEffect(() => {
    return () => {
      props.resetCreateNewsletter()
    }
  }, [])

  function onSubmit(values) {
    props.createNewsletter(values, previewImg, mainImg, () => {
      toast.success('Noticia creada satisfactoriamente')
      props.history.push('/administration/newsletters')
    })
  }

  function renderInputField(field) {
    const { meta: { touched, error } } = field
    const hasError = touched && error ? true : false
    const labelClass = field.labelClass ? field.labelClass : 'mt-1'

    return <FormGroup row>
      <Col md='2' lg='1'>
        <Label className={labelClass} >{field.label}</Label>
      </Col>
      <Col xs="12" md="5">
        <Input {...field.input} invalid={hasError} type={field.type} />
        {hasError == true
          ? <FormFeedback>{error}</FormFeedback>
          : null
        }
      </Col>
    </FormGroup>
  }

  return loading
    ? <MainLoader />
    : <div className='animated'>
      <Card>
        <CardHeader>
          Nueva Noticia
      </CardHeader>
        <CardBody>
          {
            error && (
              <Alert color="danger">
                {error}
              </Alert>
            )
          }
          <Form onSubmit={handleSubmit(handleSubmit(onSubmit))} >
            <Field name='title' label='Titulo *:' type='text' component={renderInputField} />
            <Field name='hashTags' label='Hash Tags *:' type='text' component={renderInputField} />
            <Field name='short_desc' label='Descripción corta *:' type='text' component={renderInputField} />
            <Field name='large_desc' label='Texto de la noticia *:' type='textarea' component={renderInputField} />
            <FormGroup row>
              <Col md='2' lg='1'>
                <Label>Foto previa *(600x600):</Label>
              </Col>
              <Col xs="12" md="5">
                <FilePond
                  labelIdle='Arrastra y Suelta una foto o <span class="filepond--label-action"> Elige </span>'
                  acceptedFileTypes='image/jpeg, image/png'
                  required={true}
                  labelFileTypeNotAllowed='Archivo no válido'
                  onupdatefiles={fileItems => {
                    if (fileItems.length == 0) return;
                    setPreviewImg(fileItems[0].file)
                  }}
                  onremovefile={file => {
                    setPreviewImg(null)
                  }}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col md='2' lg='1'>
                <Label>Foto principal *(1280x720):</Label>
              </Col>
              <Col xs="12" md="5">
                <FilePond
                  labelIdle='Arrastra y Suelta una foto o <span class="filepond--label-action"> Elige </span>'
                  acceptedFileTypes='image/jpeg, image/png'
                  labelFileTypeNotAllowed='Archivo no válido'
                  required={true}
                  onupdatefiles={fileItems => {
                    if (fileItems.length == 0) return;
                    setMainImg(fileItems[0].file)
                  }}
                  onremovefile={file => {
                    setMainImg(null)
                  }}
                />
              </Col>
            </FormGroup>
            <Row>
              <Col className='mt-3'>
                <Button type='submit' disabled={loading} color='primary' className='mr-2' ><i className="fa fa-save mr-1" /> Guardar</Button>
                <Button color='secondary' onClick={() => props.history.push('/administration/newsletters')} ><i className="fa fa-chevron-left mr-1" /> Cancelar</Button>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </div>
}

function validate(values) {
  const errors = {}

  if (validationHelper.stringIsNullOrEmpty(values.title)) {
    errors.title = messages.MANDATORY_FIELD
  }
  if (validationHelper.stringIsNullOrEmpty(values.hashTags)) {
    errors.hashTags = messages.MANDATORY_FIELD
  }
  if (validationHelper.stringIsNullOrEmpty(values.short_desc)) {
    errors.short_desc = messages.MANDATORY_FIELD
  }
  if (validationHelper.stringIsNullOrEmpty(values.large_desc)) {
    errors.large_desc = messages.MANDATORY_FIELD
  }

  return errors
}

function mapStateToProps(state) {
  const { newsletter, loading, error } = state.newsletter.newNewsletter
  return {
    newsletter,
    loading,
    error
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createNewsletter,
    resetCreateNewsletter
  }, dispatch)
}

export default reduxForm({
  form: 'NewsletterAddForm',
  touchOnBlur: false,
  validate
})(
  connect(mapStateToProps, mapDispatchToProps)(NewsletterAdd)
)



// WEBPACK FOOTER //
// ./src/scenes/Administration/Newsletter/NewsletterAdd/NewsletterAdd.js